import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelRoute from 'lumen/routes/hotel';
import type { Transition } from 'lumen/services/transition';
import { reconnectBranddotcomOtas } from 'lumen/utils/disconnected-otas';
import type { ModelFrom } from 'lumen/utils/routes';

type Model = ModelFrom<HotelRoute>;

export default class HotelParityRoute extends Route {
  @service declare access: Services['access'];
  @service declare router: Services['router'];
  @service declare store: Services['store'];

  deactivate(): void {
    reconnectBranddotcomOtas(this.store);

    /**
     * In application tests, the app gets torn down after each test. This causes the store to be destroyed
     * before the deactivate hook is called. This check is to prevent the store from being accessed after it's destroyed.
     */
    if (this.store.isDestroyed) {
      return;
    }
    // this.store.unloadAll('day');
    // this.store.unloadAll('period');
    this.store.unloadAll('roomtype');
  }

  redirect(model: Model, transition: Transition): void {
    if (transition.targetName === 'hotel.parity.index') {
      // Parity insight and list are the default views
      if (this.access.hasParityAnalytics) {
        this.router.transitionTo('hotel.parity.insight');
        return;
      }
      // Parity list view is the default view
      this.router.transitionTo('hotel.parity.list');
    }
  }
}
